// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1dh8w","savePackageButton":"ClientWallet_savePackageButton__1jasS"};